import { computed } from 'mobx';

export default class DataOriginParameterModel {
  id;
  store;

  constructor(store, dataOriginParameter) {
    this.store = store;
    this.id = +dataOriginParameter.id;
    this.data_origin_id = +dataOriginParameter.data_origin_id;
    this.code = dataOriginParameter.code;
    this.parameter_id = +dataOriginParameter.parameter_id;
    this.parameter_unit_id = +dataOriginParameter.parameter_unit_id;
    this.block = +dataOriginParameter.block || 0;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      data_origin_id: +this.data_origin_id,
      code: this.code,
      parameter_id: +this.parameter_id,
      parameter_unit_id: +this.parameter_unit_id,
      block: +this.block
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.data_origin_id = +json.data_origin_id;
    this.code = json.code;
    this.parameter_id = +json.parameter_id;
    this.parameter_unit_id = +json.parameter_unit_id;
    this.block = +json.block;
  }
}



// WEBPACK FOOTER //
// ./src/models/DataOriginParameterModel.js